import MapModel        from '@models/map/MapModel';
import ThemeModel      from '@models/map/ThemeModel';
import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import MapServiceModel from '@/models/MapServiceModel';
import TimestampAble   from '@widesk-core/models/traits/TimestampAble';

export type ExtraAction = 'open_place' | 'open_url' | 'open_map';

@model.urnResource('feature')
@doc.path('/features/{?id}')
export default class FeatureModel extends TimestampAble(MapServiceModel) {
	@doc.model(MapModel) declare map: MapModel;
	@doc.model(ThemeModel) declare theme: ThemeModel;
}